import { useState } from 'react'
import { notasVentaApi } from '../api/notasVenta'
import { depositosDe } from '../utils/stockPresea'

// Stock EN VIVO desde Presea (query STOCK_NV, depósitos 100/400) para una
// pantalla de carga de artículos (NV, presupuesto). Se pide con el botón
// "Consultar stock" y se pinta por renglón con <CeldaStockPresea>. Una llamada
// al WS por código: con varios renglones tarda unos segundos. El endpoint
// acepta hasta 30 códigos por pedido → se parte en tandas.
const TANDA = 30

export default function useStockPresea() {
  const [estado, setEstado] = useState({ porCodigo: null, depositos: [], cargando: false, error: null })

  const consultar = async (codigosCrudos) => {
    const codigos = [...new Set(codigosCrudos.filter(Boolean))]
    if (codigos.length === 0) return
    setEstado(s => ({ ...s, cargando: true, error: null }))
    try {
      const porCodigo = {}
      for (let i = 0; i < codigos.length; i += TANDA) {
        const { data } = await notasVentaApi.stockPresea(codigos.slice(i, i + TANDA))
        Object.assign(porCodigo, data.stock)
      }
      setEstado({ porCodigo, depositos: depositosDe(porCodigo), cargando: false, error: null })
    } catch (err) {
      setEstado(s => ({
        ...s,
        cargando: false,
        error: err.response?.data?.message || 'Presea no respondió la consulta de stock.',
      }))
    }
  }

  return { ...estado, consultar }
}
